import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import './App.css';
import Homepage from './components/Homepage';
import ChapterList from './components/ChapterList';
import ChapterReader from './components/ChapterReader';
import UserProfile from './components/UserProfile';
import WalletPage from './components/WalletPage';
import ContactPage from './components/ContactPage';
import TermsOfService from './components/TermsOfService';
import CookiePolicy from './components/CookiePolicy';
import RefundPolicy from './components/RefundPolicy';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/chapters" element={<ChapterList />} />
            <Route path="/chapter/:chapterNumber" element={<ChapterReader />} />
            <Route path="/wallet" element={<WalletPage />} />
            <Route path="/profile" element={<UserProfile />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
          </Routes>
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
};

export default App;